import { Button, Divider } from '@mui/material';
import { canRegister } from 'domain/event/UnpyEvent.func';
import { KeyValue } from 'primary/Components/KeyValue/KeyValue';
import { LoadingScreen } from 'primary/Components/LoadingScreen/LoadingScreen';
import { routesConfig } from 'primary/Configs/Routes.config';
import {
  getNavigationLinkFromRessourceKey,
  parseRessourceFromNotificaton,
} from 'primary/MessageList/NotificationListItem';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { NotificationResourceTypeEnum } from '../../../domain/notification/NotificationResourceTypeEnum';
import { UnpyNotification } from '../../../domain/notification/UnpyNotification';
import { useContextDependency } from '../../hooks/useContextDependency';
import { useRetrieveFromDomain } from '../../hooks/useRetrieveFromDomain';
import { useTranslate } from '../../hooks/useTranslate';

interface NotificationInvitationTeamEventContentProps {
  notification: UnpyNotification;
  reFetchNotification: () => void;
  closePreview?: () => void;
}

export const NotificationInvitationParticipationEventContent = ({
  notification,
  reFetchNotification,
  closePreview,
}: NotificationInvitationTeamEventContentProps) => {
  const t = useTranslate();
  const { eventParticipantRepository, eventRepository, authRepository } =
    useContextDependency();
  const navigte = useNavigate();
  const [eventParticipant, , fetching] = useRetrieveFromDomain(
    () =>
      eventParticipantRepository.getParticipantOfEventByProfil(
        authRepository?.currentUser?.userProfil.id,
        parseInt(notification.resources[NotificationResourceTypeEnum.EVENT_ID]),
      ),
    undefined,
  );
  const [event, , fetchingEvent] = useRetrieveFromDomain(
    () =>
      eventRepository.getEventById(
        parseInt(notification.resources[NotificationResourceTypeEnum.EVENT_ID]),
      ),
    undefined,
  );

  const ressourcesParsed = parseRessourceFromNotificaton(notification);
  const navigate = useNavigate();

  const isCanRegister = canRegister(event);

  return (
    <div>
      <div className={'-keyValueContainerNotification'}>
        {ressourcesParsed
          .filter((r) => !r.isLink)
          .map((res) => (
            <KeyValue
              key={res.keyValue}
              accent
              keyValue={t(
                `notificationList.item.ressourceLabelByKey.${
                  res.keyValue as NotificationResourceTypeEnum
                }`,
              )}
              value={res.value}
            />
          ))}
      </div>
      <div className={'-linkContainerNotification'}>
        {ressourcesParsed
          .filter((r) => r.isLink)
          .map((res) => (
            <Button
              key={res.keyValue}
              variant={'outlined'}
              className={'-linkNotification'}
              onClick={() => {
                const link = getNavigationLinkFromRessourceKey(
                  res.keyValue as NotificationResourceTypeEnum,
                  res.value,
                  notification.resources,
                  notification.type,
                );
                navigate(link);
                closePreview?.();
              }}
            >
              {t(
                `notificationList.item.ressourceLabelByKey.${
                  res.keyValue as NotificationResourceTypeEnum
                }`,
              )}
            </Button>
          ))}
      </div>
      <Divider className={'-topMarged'} />
      {(fetching || fetchingEvent) && <LoadingScreen loading />}
      {!fetching && !!eventParticipant && (
        <span>{t('notification.content.inviteEvent.teamAlreadyCreated')}</span>
      )}
      {!fetchingEvent && !fetching && !eventParticipant && !isCanRegister && (
        <span>{t('notification.content.inviteEvent.perrempted')}</span>
      )}
      {!fetching && !eventParticipant && isCanRegister && event && (
        <Button
          variant={'outlined'}
          color={'primary'}
          onClick={() => {
            navigte(
              routesConfig.eventViewDetails.eventViewPlayersRegisterOpen.to(event.id),
            );
            closePreview?.();
          }}
        >
          {t('notification.content.inviteEvent.createTeam')}
        </Button>
      )}
    </div>
  );
};
